import { useMemo } from 'react';
import { IDonorConnectCompletionsReport } from '@nkr/models/index';
import { ColDef, IHeaderParams } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { GridWrapper } from './styles';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Button, Glyphicon } from 'react-bootstrap';

interface IProps {
    data: IDonorConnectCompletionsReport[],
    onGetDetails: (userId: number) => void
}

const Grid = (props: IProps) => {
    const columns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 80,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },
        {
            colId: 'mentor',
            field: 'username',
            headerName: 'Mentor',
            cellClass: 'list-cell-left',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Mentor</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorConnectCompletionsReport;

                return (
                    <Button bsSize='xs' bsStyle='link' style={{ marginRight: 5 }} onClick={() => props.onGetDetails(data.userId)}><Glyphicon glyph='modal-window' style={{ marginRight: 5 }} />{data.username}</Button>
                );
            }
        },
        {
            colId: 'firstContactsAssigned',
            field: 'firstContactsAssigned',
            headerName: 'First Contacts Assigned',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Contact<br />Assigned</SortableHeaderComponent>,
        },
        {
            colId: 'firstContactAttempts',
            field: 'firstContactAttempts',
            headerName: 'First Contacts Attempts',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Contact<br />Attempts</SortableHeaderComponent>,
        },
        {
            colId: 'firstContactsMade',
            field: 'firstContactsMade',
            headerName: 'First Contacts Made',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Contacts<br />Made</SortableHeaderComponent>,
        },
        {
            colId: 'surveysCompletedForWorkup',
            field: 'surveysCompletedForWorkup',
            headerName: 'Workup Surveys',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Workup<br />Surveys</SortableHeaderComponent>,
        },
        {
            colId: 'surveysCompletedForPreOp',
            field: 'surveysCompletedForPreOp',
            headerName: 'Pre-Op Surveys',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Pre-Op<br />Surveys</SortableHeaderComponent>,
        },
        {
            colId: 'surveysCompletedAtSurgery',
            field: 'surveysCompletedAtSurgery',
            headerName: 'At-Surgery Surveys',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>At-Surgery<br />Surveys</SortableHeaderComponent>,
        },
        {
            colId: 'surveysCompletedPostSurgery',
            field: 'surveysCompletedPostSurgery',
            headerName: 'Post-Surgery Surveys',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Post-Surgery<br />Surveys</SortableHeaderComponent>,
        },
        {
            colId: 'donationsMade',
            field: 'donationsMade',
            headerName: 'Donations Made',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Donations<br />Made</SortableHeaderComponent>,
        },
    ];

    const columnDefs = useMemo(() => columns, []);

    return (
        <GridWrapper className='ag-theme-bootstrap' style={{ height: '75vh' }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={props.data}
                headerHeight={42}
                suppressCellSelection={true}
                suppressContextMenu={true}
                rowSelection='single'
                noRowsOverlayComponentFramework={() => props.data.length == 0 ? <>No records found...</> : null}
                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
            />
        </GridWrapper>
    );
}

export default Grid;